import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const CanonicalTag = () => {
  const location = useLocation();
  const baseUrl = process.env.REACT_APP_SITE_URL || "https://doaguru.com";
  
  let path = location.pathname;
  
  // Normalize trailing slashes: Remove trailing slashes for non-root paths
  if (path !== '/' && path.endsWith('/')) {
    path = path.replace(/\/+$/, '');
  }

  // Ensure no duplicate slashes exist anywhere in the path
  path = path.replace(/\/{2,}/g, '/');

  const canonicalUrl = `${baseUrl}${path}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default CanonicalTag;
